<template>
  <div class="text-center">
    <v-dialog v-model="formDialog" width="600" persistent>
      <v-card>
        <v-card-title class="text-h5">
          {{ medication.Medication }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-5">
          <v-alert v-if="showError" dense border="left" type="error">
            Please add <strong>Target BG</strong>
          </v-alert>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="item.bg"
                label="BG"
                placeholder="mg/dL"
                type="number"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="bgUnits"
                label="Units"
                readonly
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="item.carbs"
                label="Carbs"
                placeholder="Carbohydrates"
                type="number"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="carbUnits"
                label="Units"
                readonly
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-subheader class="justify-end"
                >Insulin to Administer</v-subheader
              >
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="totalUnits"
                label="Amount"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>

          <div>
            <v-alert
              border="left"
              colored-border
              color="blue accent-2"
              elevation="2"
            >
              <div class="mb-3"><i>*Notes</i> <br /></div>
              <div class="mb-3">
                <b>Card Ratio </b> <br />
                12 Carbs: 1 unit <br />
              </div>
              <div class="mb-3">
                <b>Insulin Ratio (Above Target)</b> <br />
                30 mg/dL : 1 Unit <br />
              </div>
              <div>
                <b>Target BG</b> <br />
                <div class="mt-1" v-if="medication.times != 'prn'">
                  {{ medication.targetBg }} mg/dL
                </div>
                <div class="mt-2" v-else>
                  <v-row>
                    <v-col cols="3">
                      <v-text-field
                        v-model="targetBg"
                        label="mg/dL"
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-alert>
          </div>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDialog">Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
    },
    medication: {
      default: () => {},
    },
  },
  data() {
    return {
      formDialog: this.dialog,
      item: {
        carbRatio: 12,
        insulinRatio: 30,
        tagetBg: this.medication.targetBg,
        bg: this.medication.bloodSugar,
        carbs: 0,
      },
      targetBg: 0,
      showError: false,
    };
  },

  watch: {
    dialog(newVal) {
      this.formDialog = newVal;
    },
    "medication.bloodSugar"(val) {
      return (this.item.bg = val);
    },
  },

  computed: {
    targetBgVal() {
      if (this.medication.times !== "prn") {
        return this.medication.targetBg;
      }
      return this.targetBg;
    },

    bgUnits() {
      if (this.item.bg && this.item.bg !== 0) {
        const units =
          (this.item.bg - this.targetBgVal) / this.item.insulinRatio;
        return units.toFixed(1);
      }
      return 0;
    },
    carbUnits() {
      let units = this.item.carbs / this.item.carbRatio;
      return units.toFixed(1);
    },

    totalUnits() {
      return (parseFloat(this.bgUnits) + parseFloat(this.carbUnits)).toFixed(1);
    },
  },

  methods: {
    closeDialog() {
      if (this.targetBg === 0 && this.medication.times === "prn") {
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 1000);
        return;
      }

      this.$emit("close", { ...this.item, totalUnits: this.totalUnits });
      this.showError = false;
      this.clear();
    },

    clear() {
      this.item.bg = 0;
      this.item.carbs = 0;
      this.targetBg = 0;
    },
  },
};
</script>
